<template>
  <div class="content funerarias p-1">
    <h4 class="funerarias_title">
      <b>Funerárias</b>
    </h4>

    <div class="pl-3 pr-3">
      <b-row align-h="between">
        <div class="ml-3 mt-1 col-4 p-0">
          <div class="form-group">
            <label
              for="busca"
              class="funerarias_label">Buscar Funerária</label>
            <input
              id="busca"
              v-model="search"
              class="col-md-12 form-control form-control-sm"
              name="busca"
              placeholder="Digite o nome da funerária para pesquisa"
              type="text">
          </div>
        </div>
        <div>
          <div class="mt-3 mr-3">
            <b-button
              variant="secondary"
              size="sm"
              @click="showModal()">
              <svg
                class="button_edit_label_icon icon--xxs"
                role="presentation">
                <use :xlink:href="'#' + add.id" />
              </svg>
              Adicionar funerária
            </b-button>
          </div>
        </div>
      </b-row>

      <Table
        :fields="fields"
        :data="funerarias"
        :is-busy="isBusy"
        :search="search"
        field-search="nome"
        @showModal="showModal"
        @onUpdateAtivo="updateAtivo"
        @deleteItem="deleteFuneraria" />
    </div>

    <Pagination
      :per-page="perPage"
      :page="page"
      :last-page="lastPage"
      @onPreviousPage="previousPage"
      @onNextPage="nextPage" />

    <form
      autocomplete="off"
      class="no-padding"
      @submit.prevent="callMethod()">
      <BoxModal
        :read="read"
        :form="form"
        :tipo="'Funerária'"
        @changeRead="changeRead"
        @onEnderecoAdd="changeData" />
    </form>
  </div>
</template>

<script>
  /* components */
  import Pagination from "@/components/SofiaRei/Pagination"
  import Table from "@/components/SofiaRei/Table"
  import BoxModal from "@/components/SofiaRei/Cruds/BoxModal"

  /* services */
  import FunerariaSugestaoService from "@/services/Registros/Obito/FunerariaSugestaoService"

  /* assets */
  import excludeIcon from "@/assets/icons/ic_delete_24px.svg?sprite"
  import editIcon from "@/assets/icons/pencil.svg?sprite"
  import eyeIcon from "@/assets/icons/eye.svg?sprite"

  import add from '@/assets/icons/add.svg?sprite'
  /* outros */
  import debounce from 'lodash/debounce'
  import { mapGetters } from 'vuex'

  export default {
    name: "Funerarias",
    components: {
      Pagination,
      Table,
      BoxModal,
    },
    data () {
      return {
        search: null,
        isBusy: false,
        perPage: 10,
        page: 1,
        lastPage: 1,
        excludeIcon,
        editIcon,
        eyeIcon,
        add,
        read: false,
        title: 'Nova funerária',
        fields: [{
          key: 'id',
          label: 'Ativo'
        },{
          key: 'nome',
          label: 'Nome'
        },{
          key: 'telefone',
          label: 'Telefone'
        },{
          key: 'email',
          label: 'Email'
        },{
          key: 'endereco.uf',
          label: 'Estado'
        },{
          key: 'endereco.cidade',
          label: 'Cidade'
        },{
          key: 'acoes2',
          label: ''
        }],
        funerarias: [],
        form: {
          cartorio_id: this.$store.state.auth.cartorio_id,
          nome: null,
          telefone: null,
          email: null,
          ativo: 1,
          endereco: {
            cep: null,
            logradouro: null,
            numero: null,
            complemento: null,
            bairro: null,
            cidade: null,
            uf: null,
            codigo_ibge_id: null
          }
        }
      }
    },
    computed: {
      ...mapGetters({
        cartorioId: 'auth/getCartorioId'
      }),
    },
    watch: {
      search: function (newSearch, oldSearch) {
        this.isBusy = true
        this.viewWatch()
      }
    },
    beforeMount () {
      try {
        loader({ text: "Obtendo dados...", active: true })
        this.init()
      } catch (e) {
        loader({ text: "", active: false })
      }
    },
    created () {
      this.viewWatch = debounce(function () {
        this.searchFuneraria()
      }, 200)
    },
    methods: {
      async init () {
        const funerariaSugestao = await FunerariaSugestaoService.getFunerariaSugestao({
          cartorio_id: this.$store.state.auth.cartorio_id,
          perPage: this.perPage,
          page: this.page
        })

        this.funerarias = funerariaSugestao.data
        this.funerarias.map((s) => {
          if (s.telefone) {
            s.telefone = s.telefone.replace(/(\d{2})(\d{4})(\d{4})/, "($1)$2-$3")
          }
        })

        this.lastPage = funerariaSugestao.lastPage
        this.isBusy = false

        loader({ text: "", active: false })
      },
      async showModal (funeraria = { data: {}, read: false }) {
        const { data, read } = funeraria
        this.read = read

        if (data && data.funeraria_sugestao_id) {
          this.form = {
            funeraria_sugestao_id: data.funeraria_sugestao_id,
            nome: data.nome,
            email: data.email,
            telefone: data.telefone,
            ativo: data.ativo,
            endereco: data.endereco,
            editar: true
          }
        } else {
          this.form = {
            cartorio_id: this.$store.state.auth.cartorio_id,
            nome: null,
            telefone: null,
            email: null,
            ativo: 1,
            endereco: {
              cep: null,
              logradouro: null,
              numero: null,
              complemento: null,
              bairro: null,
              cidade: null,
              uf: null,
              codigo_ibge_id: null
            }
          }
        }

        this.$bvModal.show('modal-cadastro')
      },
      async callMethod () {
        this.$bvModal.hide('modal-cadastro')

        if (this.form.telefone) {
          this.form.telefone = this.form.telefone.replace(/[()-]/g,'')
        }

        this.form.funeraria_sugestao_id ? this.updateFuneraria(this.form) : this.saveFuneraria(this.form)
      },
      async saveFuneraria (funeraria) {
        loader({ text: "Aguarde...", active: true })

        try {
          await FunerariaSugestaoService.storeFunerariaSugestao(funeraria)

          this.displaySuccess('Salvo com sucesso!')
        } catch (error) {
          const message = getErrors(error)

          return displayMessage('error', 'Erro!', message.message)
        } finally {
          await this.init()

          loader({ text: "", active: false })
        }
      },
      async updateFuneraria (funeraria, alert = true) {
        loader({ text: "Aguarde...", active: true })

        try {
          funeraria.cartorio_id = this.$store.state.auth.cartorio_id

          await FunerariaSugestaoService.updateFunerariaSugestao(funeraria, funeraria.funeraria_sugestao_id)

          if (alert) this.displaySuccess('Atualizado com sucesso!')
        }
        catch (error) {
          const message = getErrors(error)

          return displayMessage('error', 'Erro!', message.message)
        } finally {
          await this.init()

          loader({ text: "", active: false })
        }
      },
      async deleteFuneraria (funeraria) {
        loader({ text: "Aguarde...", active: true })

        try {
          await FunerariaSugestaoService.destroyFunerariaSugestao(funeraria.funeraria_sugestao_id)

          await this.init()

          this.displaySuccess('Excluido com sucesso!')
        } catch (error) {
          const message = getErrors(error)

          return displayMessage('error', 'Erro!', message.message)
        } finally {
          loader({ text: "", active: false })
        }
      },
      displaySuccess (title = null, text = null) {
        objSwal.success.title = title || 'Realizado com sucesso!'
        objSwal.success.text = text
        objSwal.success.html = ''
        return Swal.fire(objSwal.success)
      },
      displayError (title = null, text = null) {
        objSwal.error.title = title || 'Error, tente novamente!'
        objSwal.error.text = text
        objSwal.error.html = ''
        return Swal.fire(objSwal.error)
      },
      previousPage () {
        this.isBusy = !this.isBusy
        this.page -= 1
        this.init()
      },
      nextPage () {
        this.isBusy = !this.isBusy
        this.page += 1
        this.init()
      },
      async searchFuneraria () {
        const funerariaSugestao = await FunerariaSugestaoService.getFunerariaSugestao({
          cartorio_id: this.$store.state.auth.cartorio_id,
          nome: this.search
        })

        this.funerarias = funerariaSugestao.data
        this.funerarias.map((s) => {
          if (s.telefone) {
            s.telefone = s.telefone.replace(/(\d{2})(\d{4})(\d{4})/, "($1)$2-$3")
          }
        })

        this.lastPage = funerariaSugestao.lastPage
        this.isBusy = false
      },
      updateAtivo (data) {
        const obj = {
          ...data,
          cartorio_id: this.$store.state.auth.cartorio_id,
          ativo: !data.ativo,
        }

        if (obj.telefone) {
          obj.telefone = obj.telefone.replace(/[()-]/g,'')
        }

        this.updateFuneraria(obj,false)
      },
      changeRead () {
        this.read = !this.read
      },
      changeData (endereco) {
        this.form.endereco = endereco
      },
    }
  }
</script>

<style lang="scss" >
  @import "../../scss/_utilities/_exports";

  .button_edit_label_icon {
    fill: #fff;
  }

  .button_delete_label_icon {
    fill: #fff;
  }

  .funerarias{
      &_title {
        background-color: $sinoreg-blue;
        color: $color-white;
        font-size: pxToRem(24);
        font-weight: 500;
        padding: pxToRem(10) pxToRem(20);
      }

      &_label {
        font-size: pxToRem(16);
      }
  }
</style>
